<template>
	<div class="drawer">
		<el-drawer
		size="500px"
		title="体重记录"
		:visible.sync="drawerStatus"
		@close='close'
		>
			<el-form ref="dialogPlanForm" style="padding-top:0px;">
				<el-table class="table" :data="weightRecord" style="width: 100%">
					<el-table-column prop="weight" label="体重" width="70px">
						<template slot-scope='scope'>
							{{scope.row.weight+'kg'}}
						</template>
					</el-table-column>
					<el-table-column prop="weight_reamrk" label="体重备注" width="220px">
					</el-table-column>
					<el-table-column prop="user_name" label="经办人" width="70px">
					</el-table-column>
					<el-table-column prop="zip" label="添加时间" >
						<template slot-scope='scope'>
							{{$public.FTime(scope.row.create_time)}}
						</template>
					</el-table-column>
				</el-table>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				weightRecord:[],
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
		},
		mounted() {
			this.$nextTick(()=>{
				this.drawerStatus=true
			})
			this.weightRecord = this.curPetInfo.weight_records.reverse();
		},
		methods: {
			close(){
				this.$emit("submit",{type:'close'})
			},
			// 保存基本信息
			submit() {
				this.$emit("submit",{type:'success'})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: $mainColor;
				}
			}
		}
	}
	
</style>
